import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { StoreDashboardComponent } from './surveys/store-dashboard/store-dashboard.component';
import { ActionDetailsComponent } from './surveys/action-details/action-details.component';
import { ActionsDrillDownComponent } from './surveys/actions-drill-down/actions-drill-down.component';
import { MrrActionsDrillDownComponent } from './mrr-surveys/mrr-actions-drill-down/mrr-actions-drill-down.component';
import { AdminReportsComponent } from './surveys/admin-reports/admin-reports.component';
import { CsaAuthGuard } from './auth/csa-auth.guard';
import { ErrorPageComponent } from './surveys/error-page/error-page.component';
import { MoreEvidenceComponent } from './surveys/more-evidence/more-evidence.component';
import { MoreOntheflySurveysComponent } from './adhoc-surveys/more-onthefly-surveys/more-onthefly-surveys.component';
import { MoreRecurringSurveysComponent } from './recurring-survey/more-recurring-surveys/more-recurring-surveys.component';
import { MoreTemplatesComponent } from './surveys/more-templates/more-templates.component';
import { OnTheFlySurveyDetailsComponent } from './adhoc-surveys/on-the-fly-survey-details/on-the-fly-survey-details.component';
import { RecurringSurveyDetailsComponent } from './recurring-survey/recurring-survey-details/recurring-survey-details.component';
import { AssessmentResponseViewComponent } from './surveys/assessment-response-view/assessment-response-view.component';
import { AssessmentResponseEditComponent } from './surveys/assessment-response-edit/assessment-response-edit.component';
import { AssessmentOverviewComponent } from './surveys/assessment-overview/assessment-overview.component';
import { TemplateDetailsComponent } from './surveys/template-details/template-details.component';
import { ThankYouComponent } from './surveys/thank-you/thank-you.component';
import { MrrSurveyDetailsComponent } from './mrr-surveys/mrr-survey-details/mrr-survey-details.component';
import { MoreMrrSurveysComponent } from './mrr-surveys/more-mrr-surveys/more-mrr-surveys.component';
import { ThankYouMrrComponent } from './mrr-surveys/thank-you-mrr/thank-you-mrr.component';
import { MrrActionDetailsComponent } from './mrr-surveys/mrr-action-details/mrr-action-details.component';
import { LoginComponent } from './auth/login/login.component';
import { DeveloperHandbookComponent } from './developer-handbook/developer-handbook.component';
import { MultiStoreSelectionComponent } from './multi-store-selection/multi-store-selection.component';
import { SwitchDivisionComponent } from './switch-division/switch-division.component';
import { ToDoListComponent } from './to-do-list/to-do-list.component';
import { SubfeatureRouteGuard } from './shared/subfeature-route-guard/subfeature-route-guard';
import { OnceOffSurveysComponent } from './surveys/once-off-surveys/once-off-surveys.component';
import { MrrResponseComponent } from './mrr-surveys/mrr-response/mrr-response.component';
import { SwitchLocationComponent } from './switch-location/switch-location.component';
import { LogoutComponent } from './auth/logout/logout.component';
import { SelectSessionRoleComponent } from './select-session-role/select-session-role/select-session-role.component';

const routes: Routes = [
  {
    path: 'developer-handbook',
    component: DeveloperHandbookComponent,
    data: { breadcrumbKey: 'developer-handbook' },
  },
  {
    path: 'once-off-surveys',
    component: OnceOffSurveysComponent,
    canActivate: [CsaAuthGuard, SubfeatureRouteGuard],
    data: { breadcrumbKey: 'once-off-assessments', subfeature: 'onceOffAssessments.view' },
  },
  {
    path: 'above-store-landing/once-off-survey-details/:id',
    component: AssessmentOverviewComponent,
    canActivate: [CsaAuthGuard, SubfeatureRouteGuard],
    data: { breadcrumbKey: 'above-store-once-off-survey-details', subfeature: 'onceOffAssessments.viewOverview' },
  },
  {
    path: 'store-dashboard',
    component: StoreDashboardComponent,
    canActivate: [CsaAuthGuard, SubfeatureRouteGuard],
    data: { breadcrumbKey: 'store-dashboard', subfeature: 'manageStores.view' },
    
  },
  {
    path: 'action-details/:id',
    component: ActionDetailsComponent,
    canActivate: [CsaAuthGuard, SubfeatureRouteGuard],
    data: { breadcrumbKey: 'action-details', subfeature: 'actionDetails.view' },
  },
  {
    path: 'mrr-action-details/:id',
    component: MrrActionDetailsComponent,
    canActivate: [CsaAuthGuard, SubfeatureRouteGuard],
    data: { breadcrumbKey: 'mrr-action-details', subfeature: 'mrrActionDetails.view' },
  },
  {
    path: 'to-do-list',
    component: ToDoListComponent,
    canActivate: [CsaAuthGuard, SubfeatureRouteGuard],
    data: { breadcrumbKey: 'to-do-list', subfeature: 'storeToDoList.view' }
  },
  {
    path: 'admin-landing/more-templates',
    component: MoreTemplatesComponent,
    canActivate: [CsaAuthGuard, SubfeatureRouteGuard],
    data: { breadcrumbKey: 'admin-more-templates', subfeature: 'templates.view' },
  },
  {
    path: 'once-off-assessment-overview/:id',
    component: AssessmentOverviewComponent,
    canActivate: [CsaAuthGuard, SubfeatureRouteGuard],
    data: { breadcrumbKey: 'admin-once-off-survey-details', subfeature: 'onceOffAssessments.viewOverview' },
  },
  {
    path: 'mrr-response/:id',
    component: MrrResponseComponent,
    canActivate: [CsaAuthGuard, SubfeatureRouteGuard],
    data: { breadcrumbKey: 'mrr-response-details', subfeatures: ['mrrAssessments.viewDraftResponse', 'mrrAssessments.viewResponse'] },
  },
  {
    path: 'admin-landing/reports',
    component: AdminReportsComponent,
    canActivate: [CsaAuthGuard, SubfeatureRouteGuard],
    data: { breadcrumbKey: 'admin-reports', subfeature: 'charts.view' },
  },
  {
    path: 'error/:id',
    component: ErrorPageComponent,
    data: { breadcrumbKey: 'error', hideNav: true }
  },
  {
    path: 'login',
    component: LoginComponent,
    data: { breadcrumbKey: 'login' }
  },
  {
    path: 'logout',
    component: LogoutComponent,
    data: {}
  },
  {
    path: 'more-actions',
    component: ActionsDrillDownComponent,
    canActivate: [CsaAuthGuard, SubfeatureRouteGuard],
    data: {
      subfeature: 'actions.view', breadcrumbKey: 'more-actions'
    },
  },
  {
    path: 'mrr-more-actions',
    component: MrrActionsDrillDownComponent,
    canActivate: [CsaAuthGuard, SubfeatureRouteGuard],
    data: {
      subfeature: 'mrrActions.view', breadcrumbKey: 'mrr-more-actions'
    },
  },
  {
    path: 'more-evidence/standard',
    component: MoreEvidenceComponent,
    canActivate: [CsaAuthGuard, SubfeatureRouteGuard],
    data: { breadcrumbKey: 'more-evidence', subfeature: 'standardEvidence.view' },
  },
  {
    path: 'more-evidence/mrr',
    component: MoreEvidenceComponent,
    canActivate: [CsaAuthGuard, SubfeatureRouteGuard],
    data: { breadcrumbKey: 'more-evidence', subfeature: 'mrrEvidence.view' },
  }, 
  {
    path: 'more-onthefly-surveys',
    component: MoreOntheflySurveysComponent,
    canActivate: [CsaAuthGuard, SubfeatureRouteGuard],
    data: { breadcrumbKey: 'more-onthefly-surveys', subfeature: 'adhocAssessments.view' },
  },
  {
    path: 'more-recurring-surveys',
    component: MoreRecurringSurveysComponent,
    canActivate: [CsaAuthGuard, SubfeatureRouteGuard],
    data: { breadcrumbKey: 'more-recurring-surveys', subfeature: 'recurringAssessments.view' },
  },
  {
    path: 'more-mrr-surveys',
    component: MoreMrrSurveysComponent,
    canActivate: [CsaAuthGuard, SubfeatureRouteGuard],
    data: { breadcrumbKey: 'more-mrr-surveys', subfeature: 'mrrAssessments.view' },
  },
  {
    path: 'mrr-survey-details/:id',
    component: MrrSurveyDetailsComponent,
    canActivate: [CsaAuthGuard, SubfeatureRouteGuard],
    data: { breadcrumbKey: 'mrr-survey-details', subfeature: 'mrrSurveyDetails.view' },
  },
  {
    path: 'onthefly-survey-details/:id',
    component: OnTheFlySurveyDetailsComponent,
    canActivate: [CsaAuthGuard, SubfeatureRouteGuard],
    data: { breadcrumbKey: 'onthefly-survey-details', subfeature: 'adhocAssessments.viewDetails' },
  },
  {
    path: 'recurring-survey-details/:id',
    component: RecurringSurveyDetailsComponent,
    canActivate: [CsaAuthGuard, SubfeatureRouteGuard],
    data: { breadcrumbKey: 'recurring-survey-details', subfeature: 'recurringAssessments.viewOverview' },
  },
  {
    path: 'assessment-response-edit/:id',
    component: AssessmentResponseEditComponent,
    canActivate: [CsaAuthGuard, SubfeatureRouteGuard],
    data: { breadcrumbKey: 'store-surveys', subfeatures: ['onceOffAssessments.editResponse', 'recurringAssessments.editResponse', 'adhocAssessments.editResponse'] },
  },
  {
    path: 'assessment-response-view/:id',
    component: AssessmentResponseViewComponent,
    canActivate: [CsaAuthGuard, SubfeatureRouteGuard],
    data: { breadcrumbKey: 'store-survey-details', subfeatures: ['onceOffAssessments.viewResponse', 'recurringAssessments.viewResponse', 'adhocAssessments.viewResponse'] },
  },
  {
    path: 'template-details/:id',
    component: TemplateDetailsComponent,
    canActivate: [CsaAuthGuard, SubfeatureRouteGuard],
    data: { breadcrumbKey: 'template-details', subfeature: 'templates.view' },
  },
  {
    path: 'support-landing',
    component: SelectSessionRoleComponent,
    canActivate: [CsaAuthGuard, SubfeatureRouteGuard],
    data: { breadcrumbKey: 'support-landing', subfeatures: ['navigation.canAccessAsOtherRoles'], hideNav: true },
  },
  {
    path: 'switch-location',
    component: SwitchLocationComponent,
    canActivate: [CsaAuthGuard],
    data: { breadcrumbKey: 'switch-location', hideNav: true },
  },
  {
    path: 'switch-division',
    component: SwitchDivisionComponent,
    canActivate: [CsaAuthGuard, SubfeatureRouteGuard],
    data: { subfeatures: ['navigation.canAccessAsOtherDivisions'], breadcrumbKey: 'switch-division', hideNav: true },
  },
  {
    path: 'multi-store-selection',
    component: MultiStoreSelectionComponent,
    canActivate: [CsaAuthGuard, SubfeatureRouteGuard],
    data: { subfeatures: ['navigation.canAccessAsOtherStores'], breadcrumbKey: 'multi-store-selection', hideNav: true },
  },
  {
    path: 'thankyou',
    component: ThankYouComponent,
    data: { breadcrumbKey: 'thankyou' },
  },
  {
    path: 'thankyouMrr/:id',
    component: ThankYouMrrComponent,
    data: { breadcrumbKey: 'thankyou-mrr' },
  },
  {
    path: '',
    loadChildren: () => import('./dashboard/dashboard.module').then((m) => m.DashboardModule),
    canActivate: [CsaAuthGuard, SubfeatureRouteGuard],
    data: { breadcrumbKey: 'dashboard', subfeature: 'dashboard.view' },
  },
  {
    path: 'access-management',
    loadChildren: () => import('./access-management/access-management.module').then((m) => m.AccessManagementModule)
  },
  {
    path: '**',
    component: ErrorPageComponent,
    data: { breadcrumbKey: 'error', hideNav: true }
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { enableTracing: false, relativeLinkResolution: 'legacy' })],
  exports: [RouterModule],
})
export class AppRoutingModule { }
